<template>
  <div>
    <yxt-drawer
      :title="title"
      size="640px"
      :visible.sync="visible"
      :before-close="cancleMessageBox"
    >
    <section class="yxt-upload-explain__section">
      <!--说明-->
      <ul class="yxt-upload-explain-list">
        <li>
          <span class="yxt-upload-explain-num color-gray-8">1</span>
          <div class="standard-size-14 color-gray-10 yxt-upload-explain-title">
            {{
              $t("pc_gwnl_import_downloadTemplate", {
                btnName: $t("pc_gwnl_import_download"),
              })
            }}
          </div>
          <div class="yxt-upload-explain-summary color-gray-8">
            <span class="color-red-6">{{
              $t("pc_gwnl_import_readInstructions")
            }}</span>
            {{ $t("pc_gwnl_import_fillRequired") }}
          </div>
          <yxt-button
            class="mt16"
            type="primary"
            :loading="btnDisabled"
            @click="downloadExcel"
          >
            {{ $t("pc_gwnl_import_download") }}
          </yxt-button>
        </li>
        <li>
          <span class="yxt-upload-explain-num color-gray-8">2</span>
          <div class="standard-size-14 color-gray-10 yxt-upload-explain-title">
            {{ $t("pc_gwnl_import_instruction1") }}
          </div>
          <div class="yxt-upload-explain-summary color-gray-8">
            {{ $t("pc_gwnl_import_instruction2") }}
          </div>
        </li>
      </ul>
      <!--上传-->
      <div
        v-if="step === 1"
        class="yxt-upload-container"
      >
      <yxtbiz-upload
          ref="bizUpload"
          source="501"
          config-key="AttachConfigKey"
          module-name="attach"
          function-name="import"
          :app-code="module"
          :before-upload="beforeUpload"
          :on-progress="onProgress"
          :on-uploaded="onUploaded"
          :on-error="onError"
          :drag="true"
          filters=".xlsx,.xls"
          :files-filter="filesFilter"
        >
          <div slot="tip">
            {{ $t("pc_gwnl_import_supportExtension") }}
          </div>
        </yxtbiz-upload>
      </div>
      <!-- 2.0消息通知内容优化 -->
      <div v-if="step === 2" class="ml45">
        <div class="color-gray-10 yxt-upload-item-title font-size-12 yxt-row is-align-middle yxt-row--flex">
          <span>{{ file.name }}</span>
          <i class="yxt-icon-close hand standard-size-12 color-gray-8 hover-primary-6 ml16" @click="reset" />
        </div>
        <div class="mt16 yxt-row is-align-middle pt16 pb16 pl20 pr20 color-gray-7 bg-gray-1">
          <div class="yxtbiz-flex-center">
            <yxt-radio
              v-model="customization"
              :label="0"
            >
              {{ $t('pc_gwnl_eval_useDefaultTemplate').d('使用默认通知模板') }}
            </yxt-radio>
            <yxt-radio
              v-model="customization"
              :label="1"
            >
              {{ $t('pc_gwnl_eval_usePersonalizedTemplates').d('使用个性通知模板') }}
            </yxt-radio>
            <span
              v-if="customization === 1"
              class="color-primary-6 hand lh20"
              @click="showTemplate('talent_eval_notify')"
            >
              {{ $t('pc_eval_eval_notify').d('测评通知') }}
            </span>
          </div>
        </div>
        <yxt-button type="primary" class="mt24" @click="handleConfirmMessage">
          {{ $t('pc_eval_lbl_btn_confirmImport').d('确定导入') }}
        </yxt-button>
      </div>
      <!-- 上传进度展示 -->
      <div
        v-if="step === 3"
        class="yxt-upload-container"
      >
        <ul class="yxt-upload-item-list">
          <li class="is-completed color-primary-6">
            <span class="yxt-upload-status" />
            <yxt-row
              type="flex"
              align="middle"
              class="color-gray-10 yxt-upload-item-title"
            >
              {{ file.name }}
              <yxt-button
                type="primary"
                @click="reset"
              >
                {{
                  successCount > 0 && failedCount > 0
                    ? $t("cc_btn_continueupload")
                    : $t("pc_gwnl_import_reupload")
                }}
              </yxt-button>
            </yxt-row>
            <yxt-row
              type="flex"
              align="middle"
              class="standard-size-12 lh20 mt4"
            >
              <yxt-link
                :underline="false"
                type="success"
              >
                <i class="yxt-icon-success" />
              </yxt-link>
              <span class="color-gray-8 ml3">{{
                $t("pc_gwnl_import_uploadSuccess")
              }}</span>
            </yxt-row>
          </li>
          <li
            v-if="checking"
            class="is-active color-primary-6"
          >
            <span class="yxt-upload-status" />
            <div class="color-gray-10 yxt-upload-item-title">
              {{ $t("pc_gwnl_import_msg_checkingFormat") }}
            </div>
            <yxt-row
              type="flex"
              align="middle"
              class="standard-size-12 lh20 mt4"
            >
              <span class="color-gray-8 ml16">{{
                $t("pc_gwnl_import_checking")
              }}</span>
            </yxt-row>
          </li>
          <li
            v-if="failedCount > 0 && successCount === 0"
            class="is-active color-primary-6"
          >
            <span class="yxt-upload-status" />
            <yxt-row
              type="flex"
              align="middle"
              class="color-gray-10 yxt-upload-item-title"
            >
              {{ $t("pc_gwnl_import_abnormalFormat") }}
            </yxt-row>
            <yxt-row
              type="flex"
              align="middle"
              class="standard-size-12 lh20 mt4"
            >
              <yxt-link
                :underline="false"
                type="warning"
              >
                <i class="yxt-icon-warning" />
              </yxt-link>
              <span class="color-gray-8 ml3">{{
                $t("pc_gwnl_import_checkFailed")
              }}</span>
              <yxt-link
                class="standard-size-12 ml8"
                type="primary"
                :underline="false"
                @click="downloadError"
              >
                {{ $t("pc_gwnl_import_downloadErrDes") }}
              </yxt-link>
            </yxt-row>
          </li>
          <li
            v-if="showError"
            class="is-active color-primary-6"
          >
            <span class="yxt-upload-status" />
            <yxt-row
              type="flex"
              align="middle"
              class="color-gray-10 yxt-upload-item-title"
            >
              {{ $t("pc_gwnl_import_selectAgain") }}
            </yxt-row>
            <yxt-row
              type="flex"
              align="middle"
              class="standard-size-12 lh20 mt4"
            >
              <yxt-link
                :underline="false"
                type="danger"
              >
                <i class="yxt-icon-error" />
              </yxt-link>
              <span class="color-gray-8 ml3">{{
                errorMsg || $t("pc_gwnl_import_checkFail")
              }}</span>
            </yxt-row>
          </li>

          <li
            v-if="!checking && successCount > 0"
            class="is-completed color-primary-6"
          >
            <span class="yxt-upload-status" />
            <yxt-row
              type="flex"
              align="middle"
              class="color-gray-10 yxt-upload-item-title"
            >
              {{ $t("pc_gwnl_import_checkCompleted") }}
            </yxt-row>
            <yxt-row
              type="flex"
              align="middle"
              class="standard-size-12 lh20 mt4"
            >
              <yxt-link
                :underline="false"
                type="success"
              >
                <i class="yxt-icon-success" />
              </yxt-link>
              <span class="color-gray-8 ml3">{{
                $t("pc_gwnl_import_checkPassed")
              }}</span>
            </yxt-row>
          </li>
          <li
            v-if="!checking && successCount > 0 && failedCount === 0"
            class="is-active color-primary-6"
          >
            <span class="yxt-upload-status" />
            <yxt-row
              v-if="successCount > 0"
              type="flex"
              align="middle"
              class="color-gray-10 yxt-upload-item-title"
            >
              {{ $t("pc_gwnl_import_importSuccessCount1") }}
              <yxt-link
                class="standard-size-14"
                :underline="false"
                type="success"
              >
                {{ successCount }}
              </yxt-link>
              {{ $t("pc_gwnl_import_importSuccessCount2") }}
            </yxt-row>
            <yxt-row
              type="flex"
              align="middle"
              class="standard-size-12 lh20 mt4"
            >
              <yxt-link
                :underline="false"
                type="success"
              >
                <i class="yxt-icon-success" />
              </yxt-link>
              <span class="color-gray-8 ml3">{{
                $t("pc_gwnl_import_importSuccess")
              }}</span>
            </yxt-row>
          </li>
          <li
            v-if="successCount > 0 && failedCount > 0"
            class="is-active color-primary-6"
          >
            <span class="yxt-upload-status" />
            <yxt-row
              type="flex"
              align="middle"
              class="color-gray-10 yxt-upload-item-title"
            >
              <yxt-link
                class="standard-size-14"
                :underline="false"
                type="success"
              >
                {{ successCount }}
              </yxt-link>
              {{ $t("pc_gwnl_import_importSuccessFailed1") }}
              <yxt-link
                class="standard-size-14"
                :underline="false"
                type="danger"
              >
                {{ failedCount }}
              </yxt-link>
              {{ $t("pc_gwnl_import_importSuccessFailed2") }}
            </yxt-row>
            <yxt-row
              type="flex"
              align="middle"
              class="standard-size-12 lh20 mt4"
            >
              <yxt-link
                :underline="false"
                type="success"
              >
                <i class="yxt-icon-success" />
              </yxt-link>
              <span class="color-gray-8 ml3">{{
                $t("pc_gwnl_import_importCompleted")
              }}</span>
              <yxt-link
                class="standard-size-12 ml8"
                type="primary"
                :underline="false"
                @click="downloadError"
              >
                {{ $t("pc_gwnl_import_btn_downloadfaileddata") }}
              </yxt-link>
            </yxt-row>
          </li>

          <li
            v-if="checking || (successCount === 0 && failedCount > 0)"
            class="color-primary-6"
          >
            <span class="yxt-upload-status" />
            <div class="color-gray-8 yxt-upload-item-title">
              {{ $t("pc_gwnl_import_downloadData") }}
            </div>
          </li>
        </ul>
      </div>
    </section>

    <yxtbiz-i18n-custom-template
      code="talent_eval_notify"
      :target-id="id"
      :visible.sync="templateVisible['talent_eval_notify']"
    />
    </yxt-drawer>
  </div>
</template>

<script>
import { getDownloadStaticFile } from './service';
import commonUtil from 'yxt-biz-pc/packages/common-util';
import { getPublishEval } from 'yxt-biz-pc/packages/eval-create-drawer/src/service.js';

export default {
  name: 'YxtbizEvalImportDrawer',
  props: {
    tempUrl: {
      type: [String, Object]
    }, // 模板文件地址
    module: {
      type: String,
      default: 'talent'
    },
    // promise结构函数
    importMethods: {
      type: Function,
      default: () => {
        return new Promise((resolve, reject) => {
          reject(new Error('import error'));
        });
      }
    },
    btnDisabled: {
      type: Boolean,
      default: false
    },
    fetchTemp: { // true-点击下载请求接口
      type: Boolean,
      default: false
    },
    needResponse: { // 需要响应体
      type: Boolean,
      default: false
    },
    title: {
      type: String
    }, // 标题
    i18n: { // 需要支持国际化
      type: Boolean,
      default: false
    },
    showNotify: { // 上传以后有个确认通知的中间件
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      file: {},
      value: true,
      ruleForm: {
        type: 1
      },
      step: 1,
      checking: false, // 检查中
      showError: false, // 非正常数据模板文件，请重新选择文件！检查失败
      failedCount: 0, // 失败n条
      successCount: 0, // 成功导入n条数据
      filePath: '', // 异常说明链接
      errorMsg: '',
      visible: false,
      customization: 0,
      templateVisible: {
        talent_eval_notify: false,
        selfVisible: false,
        leaderVisible: false,
        equalVisible: false,
        subordinateVisible: false
      } // 个性模板配置弹框显示
    };
  },
  methods: {
    close() {
      this.reset();
      this.$emit('close');
    },
    cancleMessageBox(done) {
      done();
      this.close();
    },
    selectType(type) {
      if (this.ruleForm.type === type) return;
      this.ruleForm.type = type;
    },
    show() {
      this.visible = true;
    },
    success(res) {
      this.$emit('success', res);
    },
    getTemplate() {
      this.$emit('getTemplate');
    },
    // 重新上传
    reset() {
      this.file = {};
      this.value = true;
      this.checking = false;
      this.showError = false;
      this.failedCount = 0;
      this.successCount = 0;
      this.filePath = '';
      this.step = 1;
      this.errorMsg = '';
    },
    beforeUpload(file) {
      let Xls = file.name.split('.');
      if (Xls[Xls.length - 1] === 'xls' || Xls[Xls.length - 1] === 'xlsx') {
        this.file = {
          uuid: file.uuid,
          percentage: 0
        };
        if (Xls[0].length > 13) {
          this.file.name = Xls[0].slice(0, 13) + '...' + Xls[Xls.length - 1];
        } else {
          this.file.name = file.name;
        }
        this.uploadShow = true;
        this.uploading = true;
      } else {
        this.$message.warning(this.$t('pc_gwnl_import_wrongFormat'));
        return false;
      }
    },

    throttle(method) {
      clearTimeout(method.tId);
      method.tId = setTimeout(() => {
        method();
      }, 1000);
    },
    // 下载异常说明
    downloadError() {
      if (!this.clicked) {
        // 解决跳转到下载中心影响用户使用的问题
        if (this.filePath === '/sp/down/#/download/') {
          const { protocol, host } = window.location;
          window.open(`${protocol}//${host}/sp/down/#/download`, '_blank');
        } else {
          window.location.href = this.filePath;
        }
      } else {
        this.$message.warning(this.$t('pc_gwnl_import_downloading'));
      }
      this.clicked = true;
      this.throttle(() => {
        this.clicked = false;
      });
    },
    async handleImport(file) {
      this.step = 3;
      // 正在检验数据格式
      // 检查中...
      this.checking = true;
      this.errorMsg = '';
      this.importMethods(file).then(res => {
        this.checking = false;
        if (res.failedCount > 0) {
          this.filePath = res.filePath;
        }
        this.successCount = res.successCount;
        this.failedCount = res.failedCount;
        if (res.totalCount === 0) {
          this.showError = true;
        }
        if (this.successCount > 0 || this.failedCount === 0) {
          if (this.needResponse) {
            this.$emit('success', res);
          } else {
            this.$emit('success');
          }
        }
      }).catch(err => {
        if (err && err.error && err.error.key === 'apis.skill.import.excel.sheetName.error') {
          this.errorMsg = this.$t('pc_eval_import_excel_error' /* sheet名称不符，请核实 */);
        } else {
          if (err && err.error && err.error.message) {
            this.$message.error(err.error.message);
          }
        }
        // 非正常数据模板文件，请重新选择文件！
        // 检查失败
        this.checking = false;
        this.showError = true;
      });
    },
    downloadExcel() {
      if (this.fetchTemp) {
        this.$emit('getTemplate');
        return;
      }
      if (!this.tempUrl) {
        this.$message.warning(this.$t('pc_eval_tip_failed_to_download_template' /* 下载模板失败 */));
        return;
      }
      if (/^http/.test(this.tempUrl)) {
        window.location.href = this.tempUrl;
        return;
      }
      let url = '';
      if (this.i18n) {
        const lan = commonUtil.getLanguage();
        if (lan === 'en' && this.tempUrl.en) url = this.tempUrl.en;
        else if (lan === 'ha' && this.tempUrl.ha) url = this.tempUrl.ha;
        else url = this.tempUrl.zh;
      } else {
        // 判断模板的地址传入是否是字符串还是对象
        if (typeof this.tempUrl === 'string') {
          url = this.tempUrl;
        } else if (typeof this.tempUrl === 'object') {
          url = this.tempUrl.zh;
        }
      }
      if (this.$isV1) {
        window.location.href = url;
        return;
      }
      url += '.xlsx';
      getDownloadStaticFile(url).then(res => {
        if (res.downloadUrl) {
          window.location.href = res.downloadUrl;
        }
      }).catch(() => {
        this.$message.warning(this.$t('pc_eval_tip_failed_to_download_template' /* 下载模板失败 */));
      });
    },
    onError(e) {
      if (e === 'forbidden') {
        this.$message.warning(this.$t('pc_gwnl_import_wrongFormat'));
      }
    },
    httpRequest(v) {
      this.handleImport(v.file);
    },
    onSuccess(response, file) {
      // this.handleImport(file)
    },
    onUploaded(file) { // 上传文件成功事件
      this.showNotify ? this.getPublishEval(file) : this.handleImport(file);
    },
    onProgress(file, progress, event) {
      // 上传进度事件，回调参数（file：上传的文件，progress：已上传比例，event：进度事件参数）
      const f = this.getFile(file.uuid);
      if (f) {
        f.percentage = progress.toFixed(2) * 100;
      }
    },
    getFile(uuid) {
      if (this.file.uuid === uuid) {
        return this.file;
      }
    },
    filesFilter(files) {
      if (files[0] && !/.xlsx?$/.test(files[0].name)) {
        this.$message.warning(this.$t('pc_gwnl_import_wrongFormat'));
        return [];
      }
      return files;
    },
    // 打开个性化消息通知
    showTemplate(name) {
      this.templateVisible[`${name}`] = true;
    },
    // 选择消息模板后确认导入
    handleConfirmMessage() {
      this.excelFile.customization = this.customization;
      this.handleImport(this.excelFile);
    },
    getPublishEval(file) {
      if (!this.id) return;
      getPublishEval(this.id).then(res => {
        this.customization = res.customization;
        this.step = 2;
        this.excelFile = file;
      });
    }
  }
};
</script>

<styles lang="scss" scoped>
.ml45 {
  margin-left: 45px;
}
</styles>
